import { useEffect, useRef, useState } from 'react';
import secteursService from '../services/secteursService';

export function useEntrepriseLocaleSearch(query, minLength = 2) {
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    const q = String(query ?? '').trim();
    if (q.length < minLength) {
      setSuggestions([]);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);

    timerRef.current = setTimeout(async () => {
      try {
        const { entreprises } = await secteursService.getEntreprises({
          nom: q,
          limit: 15,
          page: 1,
        });
        if (!cancelled) {
          setSuggestions(entreprises);
        }
      } catch {
        if (!cancelled) {
          setSuggestions([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }, 250);

    return () => {
      cancelled = true;
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, [query, minLength]);

  return { suggestions, loading };
}
